import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { authReducer } from "./auth.slice";
import { checkInReducer } from "./checkin.slice";
import { onboardingReducer } from "./onboarding.slice";
import { activityLogReducer } from "./activityLog.slice";

export * from "./auth.slice";
export * from "./users.slice";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["loading", "error"], // properties you don't want to persist
};

const checkInPersistConfig = {
  key: "checkIn",
  storage: storage,
  blacklist: ["listingSlug","bookingSlug","checkinDate","checkoutDate"], // specify properties to ignore if needed
};

const onboardingPersistConfig = {
  key: "onboarding",
  storage: storage,
  blacklist: [], // specify properties to ignore if needed
};

const activityLogPersistConfig = {
  key: "activityLog",
  storage: storage,
  blacklist: ["value"], // specify properties to ignore if needed
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedCheckInReducer = persistReducer(checkInPersistConfig, checkInReducer);
const persistedOnboardingReducer = persistReducer(onboardingPersistConfig, onboardingReducer);
const persistedActivityLogReducer = persistReducer(activityLogPersistConfig, activityLogReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    checkIn: persistedCheckInReducer,
    onboarding: persistedOnboardingReducer,
    activityLog: persistedActivityLogReducer,
  },
});

export const persistor = persistStore(store);
